import {
  FETCH_LOCATION_BASED_DUTYTYPE_REQUEST,
  FETCH_LOCATION_BASED_DUTYTYPE_SUCCESS,
  FETCH_LOCATION_BASED_DUTYTYPE_FAILURE,
} from "../constants/LocationBasedDutyTypeConstants";

import LocationBasedDutyTypeService from "../service/LocationBasedDutyTypeService";

export const fetchLocationBasedByDutyType = (date, dutyType) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_LOCATION_BASED_DUTYTYPE_REQUEST });

    const data = await LocationBasedDutyTypeService.getAll(date, dutyType);

    dispatch({
      type: FETCH_LOCATION_BASED_DUTYTYPE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_LOCATION_BASED_DUTYTYPE_FAILURE,
      payload:
        error.response?.data?.message || error.message || "Failed to fetch",
    });
  }
};